import { dateFormat } from '../helper/StringUtils';
import { httpservice } from '../services';
import { constants } from '../constant/constant';

export const getLicenseInstances = (obj, clientObj) => (dispatch) => {
  let query;
  if (clientObj) {
    query = `${constants.API.LICENSE_INSTANCES}/${clientObj.clientId}/${clientObj.softwareId}?page=${obj.page}&size=${obj.size}`;
  } else {
    query = `${constants.API.LICENSE_INSTANCES}/${obj.id}?page=${obj.page}&size=${obj.size}`;
  }
  dispatch({
    payload: [],
    type: 'GET_LICENSE_INSTANCES_REQUEST_INITIATED',
  });

  return httpservice()
    .get(query)
    .then((instanceData) => {
      const rows = instanceData.data.response.data.licenses;
      const count = instanceData.data.response.data.totalItems;
      const finalData = rows.map((data) => (
        {
          ...data,
          status: `${data.status.charAt(0).toUpperCase()}${data.status.slice(1)}`,
          created_at: dateFormat(data.createdAt),
          activationDate: dateFormat(data.activationDate),
        }
      ));

      dispatch({
        payload: {
          data: finalData,
          count,
        },
        type: 'GET_LICENSE_INSTANCES_REQUEST_SUCCESS',
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: 'GET_LICENSE_INSTANCES_REQUEST_ERROR',
      });
    });
};

export const updateLicenseInstance = (updateData) => httpservice()
  .put(`${constants.API.UPDATE_LICENSE_INSTANCE}`, updateData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const deleteLicenseInstance = (id) => httpservice()
  .delete(`${constants.API.DELETE_LICENSE_INSTANCE}?id=${id}`)
  .then((response) => ({
    status: 1,
    data: response.data,
  }))
  .catch((error) => ({
    status: 0,
    data: error.response && error.response.data ? error.response.data : error,
  }));

export const getSingleLicenseInstance = (id) => (dispatch) => {
  const query = `${constants.API.GET_LICENSE_INSTANCE}/${id}`;
  dispatch({
    payload: [],
    type: 'GET_SINGLE_LICENSE_REQUEST_INITIATED',
  });

  return httpservice()
    .get(query)
    .then((licenseData) => {
      const rows = licenseData.data;
      const getData = rows.map((data) => (
        {
          ...data,
          status: `${data.status.charAt(0).toUpperCase()}${data.status.slice(1)}`,
        }
      ));

      dispatch({
        payload: { data: getData },
        type: 'GET_SINGLE_LICENSE_REQUEST_SUCCESS',
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: 'GET_SINGLE_LICENSE_REQUEST_ERROR',
      });
    });
};
